export default __webpack_public_path__ + "static/media/photo--sm--41.64e29459.jpg";